import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const fmt = (n) => (n == null ? '—' : `$${Number(n).toLocaleString('es-CO')}`);
const KIND = { free_over: 'Envío gratis desde', percent: 'Descuento del', fixed: 'Descuento fijo de' };
const dt = (iso) => (iso ? new Date(iso).toLocaleDateString('es-CO', { timeZone: 'America/Bogota' }) : 'sin fecha');

export const SellerShippingPromotions = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get('/sellers/me/shipping-promotions').then(({ data }) => setItems(data.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const decide = async (p, accept) => {
    if (accept && !window.confirm(`Al aceptar asumes el ${p.seller_pct}% del descuento de envío de «${p.name}». ¿Continuar?`)) return;
    try { await api.post(`/sellers/me/shipping-promotions/${p.promo_id}/acceptance`, { accept }); toast.success(accept ? 'Promoción aceptada' : 'Participación retirada'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'No se pudo guardar'); }
  };

  if (!items.length) return null;
  return (
    <div className="mt-6 border border-slate-200 bg-white p-5" data-testid="seller-shipping-promos">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Promociones de envío que requieren tu aceptación</div>
      <p className="mt-1 text-xs text-slate-500">Solo participas si aceptas. Tu parte del descuento se reflejaría en tu desembolso cuando AutoMarket active el cobro real; hoy no cambia nada.</p>
      <div className="mt-3 space-y-2">
        {items.map((p) => {
          const accepted = p.acceptance?.status === 'accepted';
          return (
            <div key={p.promo_id} className="flex flex-wrap items-center justify-between gap-2 border border-slate-100 p-3 text-sm" data-testid={`seller-promo-${p.promo_id}`}>
              <div>
                <div className="font-semibold">{p.name}</div>
                <div className="text-xs text-slate-500">
                  {KIND[p.kind]} {p.kind === 'percent' ? `${p.value}%` : p.kind === 'fixed' ? fmt(p.value) : fmt(p.min_subtotal)}
                  {p.per_order_cap ? ` · tope ${fmt(p.per_order_cap)} por pedido` : ''} · {dt(p.starts_at)} – {dt(p.ends_at)} · Tú asumes {p.seller_pct}% · AutoMarket {p.automarket_pct}%
                </div>
                {p.acceptance?.status === 'expired' && <div className="text-xs text-amber-700">Las condiciones cambiaron: vuelve a aceptar si deseas participar.</div>}
              </div>
              {accepted
                ? <Button size="sm" variant="outline" className="rounded-none" onClick={() => decide(p, false)} data-testid={`seller-promo-revoke-${p.promo_id}`}>Retirar participación</Button>
                : <Button size="sm" className="rounded-none bg-slate-900" onClick={() => decide(p, true)} data-testid={`seller-promo-accept-${p.promo_id}`}>Aceptar</Button>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
